import $ from 'jquery';
import { gsap, Power1 } from 'gsap';
$(document).ready(function () {
    var status = $('.pagingInfo');
    var slickElement = $('.image-slider-block .playlist-slider');
    var autoPlayElement = document.querySelector('.image-slider-block');
    var element = autoPlayElement === null || autoPlayElement === void 0 ? void 0 : autoPlayElement.dataset.autoplay;
    slickElement.on('init reInit afterChange', function (event, slick, currentSlide) {
        //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
        var i = (currentSlide ? currentSlide : 0) + 1;
        status.text(i + '/' + slick.slideCount);
    });
    $('.flip-tile-block .flip-tile-block--mobile .playlist-slider-wrapper .playlist-slider').slick({
        centerMode: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    centerMode: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                }
            },
        ]
    });
    /**
     * Flip tile animations
     */
    gsap.utils.toArray(".flip-tile-card").forEach(function (card) {
        gsap.set(card, {
            transformStyle: "preserve-3d",
            transformPerspective: 1000
        });
        const q = gsap.utils.selector(card);
        const cardFront = q(".flip-tile-card--front");
        const cardBack = q(".flip-tile-card--back");
        gsap.set(cardBack, { rotationZ: 0, rotationX: -180, rotationY: 0 });
        const duration = 1;
        card.addEventListener("mouseenter", function () {
            gsap.to(cardFront, { rotationZ: 0, rotationX: 180, rotationY: 0, zIndex: 1, duration, ease: Power1.easeInOut });
            gsap.to(cardBack, { rotationZ: 0, rotationX: 0, rotationY: 0, zIndex: 1, duration, ease: Power1.easeInOut });
        });
        card.addEventListener("mouseleave", function () {
            gsap.to(cardFront, { rotationZ: 0, rotationX: 0, rotationY: 0, zIndex: 2, duration, ease: Power1.easeInOut });
            gsap.to(cardBack, { rotationZ: 0, rotationX: -180, rotationY: 0, zIndex: 1, duration, ease: Power1.easeInOut });
        });
        card.addEventListener("focusin", function () {
            gsap.to(cardFront, { rotationZ: 0, rotationX: 180, rotationY: 0, zIndex: 1, duration, ease: Power1.easeInOut });
            gsap.to(cardBack, { rotationZ: 0, rotationX: 0, rotationY: 0, zIndex: 1, duration, ease: Power1.easeInOut });
        });
        card.addEventListener("focusout", function () {
            gsap.to(cardFront, { rotationZ: 0, rotationX: 0, rotationY: 0, zIndex: 2, duration, ease: Power1.easeInOut });
            gsap.to(cardBack, { rotationZ: 0, rotationX: -180, rotationY: 0, zIndex: 1, duration, ease: Power1.easeInOut });
        });
    });
});
